import { render, staticRenderFns } from "./PostTable.vue?vue&type=template&id=87c91836&scoped=true&"
import script from "./PostTable.vue?vue&type=script&lang=js&"
export * from "./PostTable.vue?vue&type=script&lang=js&"
import style0 from "./PostTable.vue?vue&type=style&index=0&id=87c91836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c91836",
  null
  
)

export default component.exports